module.exports = "https://cdn.realtymogul.com/static/media/icon_markets.f67e6abd.svg";